import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import useAppContext, { actions } from "../../../utils/Reducers";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalImcomingPop } from "../popup/ImcomingPop";
import moment from "moment";

const BWeighting = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    async onSearch(item) {
      await handleMasterSearch(item);
    },
  }));

  const [searchData, setSearchData] = useState([]);

  const [statusW, setStatusW] = useState("");

  const {
    store: { userInfo },
  } = useAppContext();

  const SEARCH_BEFORE_DAILY_WEIGHING_LIST =
    "/mobileweb/weighing/SP_SEARCH_BEFORE_DAILY_WEIGHING_LIST.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_BEFORE_DAILY_WEIGHING_LIST,
    },
    { manual: true }
  );

  useEffect(async () => {
    await handleMasterSearch(props.searchParameters);
  }, []);

  const handleMasterSearch = async (item) => {
    //console.log(item);
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_BEFORE_DAILY_WEIGHING_LIST,
      params: {
        schPlantCd: item.schPlantCd,
      },
    });
    setSearchData(data);
    setStatusW(data.length);
  };

  //팝업 데이터 가져오기
  const onClose = useCallback(async () => {
    handleMasterSearch(props.searchParameters);
  });

  return (
    <>
      {/*     
      <div id="menu2" className="list">
        {searchData &&
          searchData?.map((data, index) => {
            return (
              <div key={index}>
                <div className="ctitle">
                  <h1 className="carno">{data.cdNmKor}</h1>
                </div>
                <div className="cinfo">
                  <div></div>
                  <div className="no">
                    <h2>{data.wssId}</h2>
                  </div>
                  <div>
                    <div className="stat calling">중량</div>
                    <div>
                      <h2 className="date arrive" style={{ marginLeft: "0" }}>
                        {data.realWeight}kg
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div> */}
      <div id="menu2" className="list" style={{ backgroundColor: "#FFFFFF" }}>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th scope="col" style={{ textAlign: "center", width: "30px" }}>
                순번
              </th>
              <th scope="col" style={{ textAlign: "center", width: "60px" }}>
                품목
              </th>
              <th scope="col" style={{ textAlign: "center", width: "50px" }}>
                중량
              </th>
            </tr>
          </thead>
          <tbody>
            {searchData &&
              searchData?.map((data, index) => {
                return (
                  <tr>
                    <td style={{ textAlign: "center" }}>{index + 1}</td>
                    <td style={{ textAlign: "center" }}>{data.cdNmKor}</td>
                    <td style={{ textAlign: "center" }}>{data.realWeight}kg</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      {searchData?.length > 0 ? (
        <div className="res">
          <div>
            <div>총합계</div>
            <div className="val">
              <div>{searchData[0].total}</div>
            </div>
            kg
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
});

export default BWeighting;
